module.exports = __webpack_public_path__ + "img/line.b651fa09.svg";